import { BulkOperationInput, TaskInput, TasksItem } from 'types/TasksTypes';
import useHttp from '../helpers/HttpMethods';

class TicketTasksService {
  static async list(ticketId: number): Promise<TasksItem[]> {
    return useHttp().get(`/tickets/${ticketId}/tasks`);
  }

  static async findById(ticketId: number, taskId: number): Promise<TasksItem> {
    return useHttp().get(`/tickets/${ticketId}/tasks/${taskId}`);
  }

  static async create(ticketId: number, body: TaskInput): Promise<TasksItem> {
    return useHttp().post(body, `/tickets/${ticketId}/tasks`);
  }

  static async associateTemplate(ticketId: number, templateId: number): Promise<Response> {
    return useHttp().post({}, `/tickets/${ticketId}/tasks/template/${templateId}`);
  }

  static async update(
    ticketId: number,
    taskId: number,
    body: TaskInput
  ): Promise<TasksItem> {
    return useHttp().put(body, `/tickets/${ticketId}/tasks/${taskId}`);
  }

  static async trash(ticketId: number, taskId: number): Promise<Response> {
    return useHttp().del(`/tickets/${ticketId}/tasks/${taskId}`);
  }

  static async complete(ticketId: number, taskId: number): Promise<TasksItem> {
    return useHttp().putWithoutBody(
      `/tickets/${ticketId}/tasks/${taskId}/complete`
    );
  }

  static async uncomplete(
    ticketId: number,
    taskId: number
  ): Promise<TasksItem> {
    return useHttp().putWithoutBody(
      `/tickets/${ticketId}/tasks/${taskId}/uncomplete`
    );
  }

  static async bulk(
    ticketId: number,
    body: BulkOperationInput
  ): Promise<Response> {
    return useHttp().put(body, `/tickets/${ticketId}/tasks/bulk`);
  }

  static async order(
    ticketId: number,
    taskId: number,
    body: { taskAboveId: number; taskBelowId: number }
  ): Promise<Response> {
    return useHttp().post(body, `/tickets/${ticketId}/tasks/${taskId}/order`);
  }
}

export default TicketTasksService;
